<template>
  <Container
    indent="container-default sm:container-tighter pb-20"
    class="pt-6 md:pt-9"
  >
    <ClientOnly>
      <!-- eslint-disable-next-line -->
      <privacybee-widget website-id="cllupcfce49775201px3g93ova" lang="de"></privacybee-widget>
    </ClientOnly>
  </Container>
</template>

<script lang="ts" setup>
useHead({
  script: [
    { src: 'https://www.privacybee.ch/widget.js', async: true, defer: true },
  ],
})
</script>

<style lang="scss">
.KFaIpG_h1 {
  font-size: 2rem !important;
  line-height: 1.125 !important;
  font-weight: 400 !important;
  hyphens: auto;

  @screen md {
    font-size: 3.5rem !important;
    line-height: 1.1428 !important;
    letter-spacing: -0.01em;
  }
}

.KFaIpG_text,
.KFaIpG_h3,
.KFaIpG_list .KFaIpG_listElement,
.KFaIpG_link, .CCca4W_expandableText, .CCca4W_expandableName {
  font-size: 1.1875rem !important;
  line-height: 1.4736842105 !important;
  letter-spacing: -0.02em;
  color: var(--tw-prose-body) !important;

  @screen xl {
    font-size: 1.375rem !important;
    line-height: 1.545 !important;
    letter-spacing: -0.025em;
  }
}

.KFaIpG_h3 {
  margin-top: 2rem !important;
}

.KFaIpG_text div,
.KFaIpG_text strong {
  margin-top: 1.5rem !important;
  display: inline-block;
}
</style>
